module.exports = __webpack_public_path__ + "static/media/emoji4.9f86a388.png";